@let isContact = type() === dialogType.Contact;
@let isDownload = type() === dialogType.Download;
@let appName = application()?.name;

<bo-modal
  class="c-dialog-application"
  [class]="'c-dialog-application--' + type()"
  [modalHeader]="headerTemplate"
  [modalBody]="bodyTemplate"
  size="profile"
  #modal
>
  <ng-template #headerTemplate>
    <div class="c-dialog-application__header">
      @if (isContact) {
        <div class="c-dialog-application__title">{{ 'DIALOG_APP_REQUEST_TITLE' | translate }}</div>
      }

      <div class="c-dialog-application__image-wrapper" [class.contact]="isContact">
        @for (item of headerImages(); track item) {
          <img
            boDefaultImage
            [alt]="appName"
            [class]="item.class"
            [srcUrl]="item.image"
            [title]="appName"
          />
        }
      </div>
    </div>
  </ng-template>

  <ng-template #bodyTemplate>
    <div class="c-dialog-application__body">
      @if (isDownload) {
        <div class="c-dialog-application__download">
          @if (SHOW_OS_ICON_APPLICATIONS?.includes($any(appName))) {
            <img
              class="c-dialog-application__download-os-icon"
              boDefaultImage
              [alt]="deviceOs"
              [srcUrl]="IMAGE_BASE_PATH + 'logo--' + deviceOs + '.svg'"
              [title]="deviceOs"
            />
          }
          @if (!notInstallationAllowed()) {
            <div class="c-dialog-application__actions">
              <div class="c-dialog-application__button">
                <div class="c-dialog-application__button-text">
                  {{ 'MODAL_MCPRODUCTS_LABEL_OPEN' | translate: { applicationName: appName } }}
                </div>
                <div>
                  <a
                    class="button-primary"
                    [href]="application()?.link | safe: 'resourceUrl'"
                    (click)="closeModal()"
                  >
                    {{ 'MODAL_MCPRODUCTS_BTN_OPEN' | translate }}
                  </a>
                </div>
              </div>

              <div class="c-dialog-application__button">
                <div class="c-dialog-application__button-text">
                  {{ 'MODAL_MCPRODUCTS_LABEL_DOWNLOAD' | translate: { applicationName: appName } }}
                </div>

                @if (downloadList()) {
                  <div>
                    @for (item of downloadList(); track item) {
                      @if (item.os === deviceOs) {
                        <a [class]="'button-' + item.type" [href]="item.url | safe: 'url'">
                          {{ 'MODAL_MCPRODUCTS_BTN_DOWNLOAD' | translate }}
                        </a>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <p class="c-dialog-application__not-installation-text">
              {{ 'MTR_NOT_INSTALLATION_MESSAGE' | translate }}
            </p>
          }
        </div>
      } @else {
        <p class="c-dialog-application__message">{{ 'DIALOG_APP_REQUEST_MESSAGE' | translate }}</p>
      }
    </div>
  </ng-template>
</bo-modal>
